import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getNetworkList(params) {
  return request({
    url: URL.mdm.basicData.network,
    method: 'get',
    params
  })
}

export function saveNetwork(data) {
  return request({
    url: URL.mdm.basicData.network,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delNetwork(uuid) {
  return request({
    url: URL.mdm.basicData.network + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
